// Angular
import { Component } from '@angular/core';
// State
import { Store } from '@ngxs/store';

@Component({
	selector: 'cv-create-order',
	templateUrl: './create-order.component.html',
	styleUrls: ['./create-order.component.scss']
})

export class CreateOrderComponent {
	constructor(private store: Store) { }
}